<template>
  <div class="row">

      <AddMember class="col-10 col-md-8"/>
  </div>
</template>

<script>
import AddMember from './AddMember'

export default {
  name: 'Membership',
  components: {
    AddMember
  }
}
</script>

<style lang="scss" scoped>

</style>
